import { Modal } from "react-bootstrap";

export default Modal.Body;



// WEBPACK FOOTER //
// ./app/modules/shared/components/Modal/Body.jsx